<template>
    <ScrollTop :target="target" :threshold="visibilityHeight" :icon="icon" />
</template>

<script>
import ScrollTop from 'primevue/scrolltop';

export default {
    name: 'tw-backtop',
    components: {
        ScrollTop
    },
    props: {
        target: String,
        visibilityHeight: Number,
        icon: String,
        behavior: String
    }
}
</script>
